<script lang="ts">
	import {
		Text,
		SelectCard,
		Container,
		LinkWithIcon,
		CardGrid,
		Label,
	} from '@Shelly/shelly-design-system';

	import { format } from 'svelte-i18n';
	import { capFirstChar } from 'src/helpers/utilities';

	import { push } from 'svelte-spa-router';

	import { home_data } from 'src/stores/account/user';
	import { active_integrations } from 'src/stores/integrations/alexa';
	import { getLoqedDevicesNumber } from 'src/helpers/loqed_helpers';
	import { getCuryDevicesNumber } from 'src/helpers/cury_mode_helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	$: alexaConnected = $active_integrations.includes('alexa');
	$: zendureAssociated = $home_data?.zendure?.user;
	let loqedDevices = getLoqedDevicesNumber();
	let curyDevices = getCuryDevicesNumber();

	$: integrationsCards = [
		{
			id: 0,
			key: 'app_linking_pages',
			text: 'Amazon Alexa',
			descriptiveText: $format('text_integrate_amazon_alexa', {
				default: 'Easy control your devices with voice commands.',
			}),
			image: './images/alexa-logo-square.png',
			route: '/app-to-app-alexa',
			leftBadge: {
				iconColor: !alexaConnected ? '--color-muted' : '--color-success',
				icon: `fas fa-${alexaConnected ? 'check' : 'xmark'}`,
				textClass: !alexaConnected ? 'text-color-muted' : 'text-success',
				value: capFirstChar(
					alexaConnected
						? $format('connected', { default: 'connected' })
						: $format('label_not_connected', { default: 'not connected' }),
				),
			},
		},
		{
			id: 1,
			key: 'app_linking_pages',
			text: 'Cury',
			descriptiveText: $format('text_control_cury_devices', {
				default: 'Control your Cury devices with the Cury app.',
			}),
			image: './images/cury-logo.png',
			route: '/app-to-app-cury',
			leftBadge: {
				iconColor: '--color-muted',
				icon: `fas fa-microchip`,
				textClass: 'text-color-muted',
				value: `${curyDevices} ${$format('devices', { default: 'devices' })}`,
			},
			secondLeftBadge: {
				value: $format('label_new', { default: 'NEW' }),
				type: 'secondary',
			},
		},
		{
			id: 2,
			key: 'app_linking_pages',
			text: 'Zendure',
			descriptiveText: $format('text_integrate_zendure', {
				default: 'PV consumption monitoring and device management.',
			}),
			defaultText: 'app settings',
			image: './images/zendure-logo-square.png',
			route: '/zendure',
			leftBadge: {
				iconColor: !zendureAssociated ? '--color-muted' : '--color-success',
				icon: `fas fa-${zendureAssociated ? 'check' : 'xmark'}`,
				textClass: !zendureAssociated ? 'text-color-muted' : 'text-success',
				type: 'warning',
				value: capFirstChar(
					zendureAssociated
						? $format('connected', { default: 'connected' })
						: $format('label_not_connected', { default: 'not connected' }),
				),
			},
			secondLeftBadge: {
				value: $format('alpha_title', { default: 'Alpha' }),
				type: 'warning',
			},
		},
		{
			id: 3,
			key: 'app_linking_pages',
			text: 'LOQED',
			descriptiveText: $format('text_integrate_loqed_device', {
				default: 'Integrate your LOQED devices seamlessly.',
			}),
			image: './images/loqed-logo-square.png',
			route: '/loqed',
			leftBadge: {
				iconColor: loqedDevices <= 0 && '--color-muted',
				icon: 'fas fa-microchip',
				textClass: loqedDevices <= 0 && 'text-color-muted',
				type: 'default',
				value: `${loqedDevices} ${$format('devices', { default: 'devices' })}`,
			},
		},
	];
</script>

<Container class="mb-s" noScroll>
	<Text class="mb-m text-bold" size="xl"
		>{$format('available_integrations', {
			default: 'Available Integrations',
		})}</Text
	>

	<CardGrid sm={200} md={300} lg={300} noPaddingBottom>
		{#each integrationsCards as card}
			<SelectCard
				cardBgColor={$showNewLayout ? 'color-1' : undefined}
				class="width-auto"
				type="vertical"
				title={card.text}
				descriptiveText={card.descriptiveText}
				hideSecondLeftSlot={!card?.secondLeftBadge}
				customActionMinHeight
				image={card.image}
			>
				<Label
					slot="leftBadge"
					size="s"
					icon={card.leftBadge.icon}
					{...card.leftBadge.iconColor ? { iconColor: card.leftBadge.iconColor } : {}}
					value={card.leftBadge.value}
					textClass={card.leftBadge.textClass}
					noRadiusType="second"
				/>
				<Label
					slot="secondLeftBadge"
					size="xs"
					type={card?.secondLeftBadge.type}
					value={card?.secondLeftBadge.value}
					noRadiusType="third"
				/>
				<LinkWithIcon
					iconInRight
					on:click={() => push(`/settings/integrations${card.route}`)}
					slot="customAction"
					size="m"
					icon="fa-light fa-arrow-right"
					href="/"
					text={$format('button_configure', { default: 'Configure' })}
				/>
			</SelectCard>
		{/each}
	</CardGrid>
</Container>
